import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[tableCell]' })
export class TableCellDirective {
  @Input('tableCell') column!: string;
  constructor(public template: TemplateRef<any>) {}
}